<template>
    <div class="section-box" v-loading="boxLoading">
        <el-row :gutter="30">
            <el-col :span="17">
                <FixedBasicInfo 
                    ref="fixedBasicInfo" 
                    @editSubmit="editSwitch" 
                    v-if="!isEdit"
                />
                <FixedBasicInfoEdit 
                    ref="fixedBasicInfoEdit" 
                    v-if="isEdit" 
                    @editSave="saveBasicInfo"
                    @cancel="cancel"
                />
                <el-tabs type="card" v-model="tabId" @tab-click="handleClick">
                    <template v-for="(item,index) in JobTabList">
                        <el-tab-pane name="JobDetailTab" :label="item.TabName" data-label="工单信息" lazy :key="index+'JobDetailTab'" v-if="item.TabCode == 'JobDetailTab'">
                            <BasicInfo 
                                ref="basicInfo" 
                                @requireConfirm="jobRequireConfirm" 
                                v-if="!isEdit"
                            />
                            <BasicInfoEdit 
                                ref="basicInfoEdit" 
                                v-if="isEdit" 
                                @saceSuccess="saceEditSuccess" 
                                @hideBtnLoading="hideBtnLoading" 
                                @saveProductLine="saveProductLine"
                            />
                        </el-tab-pane>
                        <el-tab-pane name="JobAmountTab" :label="item.TabName" data-label="费用明细" :disabled="isEdit" lazy :key="index+'JobAmountTab'" v-if="item.TabCode == 'JobAmountTab'">
                            <JobAmountInfo ref="jobAmountInfo"/>
                        </el-tab-pane>
                        <el-tab-pane name="JobBothSidesTab" :label="item.TabName" data-label="双方信息" :disabled="isEdit" lazy :key="index+'JobBothSidesTab'" v-if="item.TabCode == 'JobBothSidesTab'">
                            <BothInfo ref="bothInfo"/>
                        </el-tab-pane>
                          <!-- 报价列表 -->
                        <el-tab-pane name="JobOfferPriceTab" :label="item.TabName" data-label="报价列表" :disabled="isEdit" lazy :key="index+'JobOfferPriceTab'" v-if="item.TabCode == 'JobOfferPriceTab'">
                            <JobOfferPrice ref="JobOfferPriceRef" @reloadJobDetail="GetWatchJobDetails()"/>
                        </el-tab-pane>
                        <el-tab-pane name="JobMatchTab" :label="item.TabName" data-label="资源池" :disabled="isEdit" lazy :key="index+'JobMatchTab'" v-if="item.TabCode == 'JobMatchTab'">
                            <ResourcePool ref="resourcePool" @submitAuditJob="saceSuccess"/>
                        </el-tab-pane>
                        <el-tab-pane name="JobProgressTab" :label="item.TabName" data-label="服务流程" :disabled="isEdit" lazy :key="index+'JobProgressTab'" v-if="item.TabCode == 'JobProgressTab'">
                            <ServiceProcess ref="serviceProcess"/>
                        </el-tab-pane>
                        <el-tab-pane name="JobServiceReportTab" :label="item.TabName" data-label="标准,自由服务报告" :disabled="isEdit" lazy :key="index+'JobServiceReportTab'" v-if="item.TabCode == 'JobServiceReportTab'">
                            <ServiceReport ref="serviceReport" @submitServiceJob="saceSuccess"/>
                        </el-tab-pane>
                        <!-- 项目型工单 -->
                        <el-tab-pane name="JobReportListTab" :label="item.TabName" data-label="服务进度" :disabled="isEdit" lazy :key="index+'JobReportListTab'" v-if="item.TabCode == 'JobReportListTab'">
                            <ServeTimeLine ref="serveTimeLine"/>
                        </el-tab-pane>
                        <el-tab-pane name="JobAmountNoteTab" :label="item.TabName" data-label="财务结算" :disabled="isEdit" lazy :key="index+'JobAmountNoteTab'" v-if="item.TabCode == 'JobAmountNoteTab'">
                            <PayNode ref="payNode" @getJobLog="getJobLogList"/>
                        </el-tab-pane>
                        <el-tab-pane name="JobContractTab" :label="item.TabName" data-label="服务合同" :disabled="isEdit" lazy :key="index+'JobContractTab'" v-if="item.TabCode == 'JobContractTab'">
                            <ServeContract ref="serveContrace"/>
                        </el-tab-pane>
                        <!-- End -->
                        <el-tab-pane name="JobEvaTab" :label="item.TabName" data-label="评价" :disabled="isEdit" lazy :key="index+'JobEvaTab'" v-if="item.TabCode == 'JobEvaTab'">
                            <Rate ref="rate"/>
                        </el-tab-pane>
                      
                    </template>
                </el-tabs>
            </el-col>
            <el-col :span="7">
                <div>
                    <StateBox ref="stateBox" @submitAuditJob="saceSuccess" @addRemarkFun="addRemarkFun" @getJobLogList="getJobLogList" @getJobOfferPrice="getJobOfferPrice"  />
                </div>
                <div style="margin-top: 20px;">
                    <JobLog ref="jobLog" :isShowEngPrice="jobLogIsShowEngPrice" />
                </div>
            </el-col>
        </el-row>
    
        <!-- 工单挂起弹窗 -->
      <JobHangUpDialog ref="jobHangUp" :jobId="jobId" :jobtype="6" :fromUrl="fromUrl" @reloadData="GetWatchJobDetails()" @clockJob="$refs.stateBox.showCloseJobDia()"  /> 

       <!-- 服务需求确认单 -->
       <JobRequireConfirm ref="jobRequireConfirm" />
  </div>
</template>
<script>
import FixedBasicInfo from './index/b2bFixedBasicInfo.vue'
import FixedBasicInfoEdit from './index/b2bFixedBasicInfoEdit.vue'
import BasicInfo from './index/b2bBasicInfo.vue'
import BasicInfoEdit from './index/b2bBasicInfoEdit.vue'
import JobAmountInfo from './index/jobAmountInfo.vue'
 
import BothInfo from './index/b2bBothInfo.vue'
import ResourcePool from './index/b2bResourcePool.vue'
import ServeTimeLine from './index/b2bServeTimeLine.vue'
import PayNode from './index/payNode.vue'
import ServeContract from './index/serveContract.vue'
import Rate from './index/rate.vue'


import ServiceProcess from './index/serviceProcess.vue'
import ServiceReport from './index/serviceReport.vue'
 
import StateBox from './index/rightFunStateBox.vue'
import JobLog from './index/jobLog.vue'
import JobHangUpDialog from './index/jobHangUpDialog.vue'
import JobRequireConfirm from './index/JobRequireConfirm.vue'
import JobOfferPrice from './index/jobOfferPrice.vue'

import {
  getJobDetails,  //工单详情
  jobHangUp,//工单挂起
} from "@/service/job";
export default {
	components:{
        FixedBasicInfo,
        FixedBasicInfoEdit,
        BasicInfo,
        BasicInfoEdit,
        JobAmountInfo,
        BothInfo,
        ResourcePool,
        ServeTimeLine,
        PayNode,
        ServeContract,
        Rate,

        ServiceProcess,
        ServiceReport,

        StateBox,
        JobLog,
        JobHangUpDialog,
        JobRequireConfirm,
        JobOfferPrice
	},
    data() {
        return {
            boxLoading: false,
            jobId: '',
            isEdit: false,

            JobTabList: [],     //tab

            tabId:'',
            jobOtherInfo: {},       //工单信息
            jobData:{},//工单详情整个数据
            fromUrl:'' //上一个页面地址
        };
    },
    // mounted(){
    //     this.jobId = this.$route.query.JobId
    //     this.GetJobDetails();
    // },
    beforeRouteEnter(to, from, next) { 
        next(vm => {
            vm.fromUrl=from.path;
            // console.log('this.fromUrl:'+vm.fromUrl);
            vm.$refs.stateBox.startCountdown()
        });
    },
    activated(){
        this.jobId = this.$route.query.JobId
        this.GetJobDetails();
    },
    created() {
       
    }, 
    computed:{
        jobLogIsShowEngPrice(){//工单日志是否展示工程师报价记录
              var isShow=this.jobOtherInfo.JobType==6&& this.jobOtherInfo.IsProjectJob==0;
            //   console.log("isShow:"+isShow+";this.jobOtherInfo.JobType:"+this.jobOtherInfo.JobType+";this.jobOtherInfo.IsProjectJob:"+this.jobOtherInfo.IsProjectJob);
              return isShow;
        }
    },
    methods: {
        // 获取工单详情
        GetJobDetails(){
            this.isEdit = false
            this.GetWatchJobDetails();
        },
        GetWatchJobDetails(){
            console.log('GetWatchJobDetails');
            this.boxLoading = true
            getJobDetails({JobId: this.jobId}).then(res => {
                this.boxLoading = false
                if(res.Result != 1) return this.$message.error(res.Message);
                this.JobTabList = res.Data.JobTabList
                this.jobOtherInfo = res.Data.JobOtherInfo;
                this.jobData = res.Data;//工单详情整个数据
                // this.jobRequireConfirm(false);
                //工单挂起
                if( this.jobOtherInfo.JobStatus!=8&& this.jobOtherInfo.HangUpStatus==1){
                    this.$refs.jobHangUp.openDia();
                }
                else{
                    this.$refs.jobHangUp.closeDia();
                }
                res.Data.JobTabList.find(obj => {
                    if(obj.IsSelect) {
                        return this.tabId = obj.TabCode
                    }
                })
                this.$nextTick(()=> {
                    this.$refs.fixedBasicInfo.getJobInfo(res.Data.JobBaseInfo,res.Data.JobOperationBtn)
                    this.$refs.jobLog.getRemarkList();
                    this.$refs.fixedBasicInfo.getJobOtherInfo(res.Data.JobOtherInfo)
                    this.$refs.stateBox.getJobStateBtnIsFun(res.Data.JobOperationBtn)
                    this.$refs.stateBox.getJobOtherInfo(res.Data.JobOtherInfo, res.Data.JobDetailInfo.Content)
                    if(this.tabId == 'JobDetailTab') {
                        let dataInfo = res.Data.JobDetailInfo
                        dataInfo.IsServiceOfferDispose = res.Data.JobBaseInfo.IsServiceOfferDispose
                        // this.$refs.basicInfo[0].getJobInfo(res.Data.JobDetailInfo)
                        this.$refs.basicInfo[0].getJobInfo(dataInfo)
                    }else{
                        this.handleClick()
                    }
                    //有报价tab则加载数据
                    var jobOfferPriceTabIndex= res.Data.JobTabList.findIndex(j=>{return j.TabCode=="JobOfferPriceTab"});
                    // console.log('jobOfferPriceTabIndex:'+jobOfferPriceTabIndex);
                    if(jobOfferPriceTabIndex>=0&&this.$refs.JobOfferPriceRef){
                        this.$refs.JobOfferPriceRef[0].getJobOfferList( this.jobData);
                    }

                    
                })
            })
        },
        // 获取编辑成功后的数据
        getJobDetailsEditFun(){
            this.boxLoading = true
            getJobDetails({JobId: this.jobId}).then(res => {
                this.boxLoading = false
                if(res.Result != 1) return this.$message.error(res.Message);
                this.$nextTick(()=> {
                    this.$refs.fixedBasicInfo.getJobInfo(res.Data.JobBaseInfo,res.Data.JobOperationBtn)
                    this.$refs.fixedBasicInfo.getJobOtherInfo(res.Data.JobOtherInfo)
                    this.$refs.stateBox.getJobStateBtnIsFun(res.Data.JobOperationBtn)
                    this.$refs.stateBox.getJobOtherInfo(res.Data.JobOtherInfo, res.Data.JobDetailInfo.Content)

                    this.jobData = res.Data;//工单详情整个数据

                    let dataInfo = res.Data.JobDetailInfo
                    dataInfo.IsServiceOfferDispose = res.Data.JobBaseInfo.IsServiceOfferDispose
                    // this.$refs.basicInfo[0].getJobInfo(res.Data.JobDetailInfo)
                    this.$refs.basicInfo[0].getJobInfo(dataInfo)

                    this.$refs.jobLog.getRemarkList();
 
                })
            })
        },
        // 获取基本型信息
        getJobDetailsFun(){
            getJobDetails({JobId: this.jobId}).then(res => {
                if(res.Result != 1) return this.$message.error(res.Message);
                this.$nextTick(()=> {
                    let dataInfo = res.Data.JobDetailInfo
                    dataInfo.IsServiceOfferDispose = res.Data.JobBaseInfo.IsServiceOfferDispose
                    // this.$refs.basicInfo[0].getJobInfo(res.Data.JobDetailInfo)
                    this.$refs.basicInfo[0].getJobInfo(dataInfo)

                    this.jobData = res.Data;//工单详情整个数据
                })
            })
        },
        // 是否编辑开关
        editSwitch(){
            this.isEdit = true
            this.tabId = 'JobDetailTab'
            var that=this;
            getJobDetails({JobId: this.jobId}).then(res => {
                if(res.Result != 1) return this.$message.error(res.Message);
                this.$nextTick(()=> {
                    // res.Data.JobBaseInfoDispose.IsShowEditBtn = res.Data.JobOperationBtn.IsShowEditBtn
                    // this.$refs.fixedBasicInfoEdit.getJobInfo(res.Data.JobBaseInfo,res.Data.JobBaseInfoDispose)
                    this.$refs.fixedBasicInfoEdit.getJobInfo(res.Data.JobBaseInfo)
                    this.$refs.fixedBasicInfoEdit.getJobOtherInfo(res.Data.JobOtherInfo)
                    let dataInfo = res.Data.JobDetailInfo
                    that.jobData = res.Data.Data;//工单详情整个数据
                    dataInfo.IsServiceOfferDispose = res.Data.JobBaseInfo.IsServiceOfferDispose
                    this.$refs.basicInfoEdit[0].getJobInfo(dataInfo,res.Data.JobOtherInfo)
                })
            })
        },
        // 保存基本信息
        saveBasicInfo(val) {
            this.$refs.basicInfoEdit[0].save(val)
        },
        // 取消基本信息
        cancel(){
            this.isEdit = false
            this.getJobDetailsEditFun()
        },
        // 取消保存loading
        hideBtnLoading(){
            this.$refs.fixedBasicInfoEdit.hideBtnLoading()
        },
        // 保存成功
        saceSuccess(){
            this.isEdit = false
            this.GetJobDetails()
        },
        // 保存编辑
        saceEditSuccess(){
            this.isEdit = false
            this.getJobDetailsEditFun()
        },
        // 保存成功产品线
        saveProductLine(){
            this.editSwitch();
        },
        handleClick(e) {
            switch(this.tabId){
                case 'JobDetailTab':
                    this.$nextTick(()=> {
                        this.getJobDetailsFun();
                    })
                    break;
                case 'JobAmountTab':
                    this.$nextTick(()=> {
                        this.$refs.jobAmountInfo[0].getJobAmountInfoFun();
                    })
                    break;
                case 'JobBothSidesTab':
                    this.$nextTick(()=> {
                        this.$refs.bothInfo[0].getJobCompanyInfo();
                    })
                    break;
                case 'JobMatchTab':
                    this.$nextTick(()=> {
                        this.$refs.resourcePool[0].getJobApplyOrderList(this.jobOtherInfo);
                    })
                    break;
                case 'JobProgressTab':
                    this.$nextTick(()=> {
                        this.$refs.serviceProcess[0].getJobProgress();
                    })
                    break;
                case 'JobServiceReportTab':
                    this.$nextTick(()=> {
                        this.$refs.serviceReport[0].getJobReportUserFun();
                    })
                    break;
                // 项目工单
                case 'JobContractTab':
                    this.$nextTick(()=> {
                        this.$refs.serveContrace[0].getJobContractFun();
                    })
                    break;
                case 'JobReportListTab':
                    this.$nextTick(()=> {
                        this.$refs.serveTimeLine[0].getTimeLine();
                    })
                    break;
                case 'JobAmountNoteTab':
                    this.$nextTick(()=> {
                        this.$refs.payNode[0].getB2bJobReportInfo();
                    })
                    break;
                // End
                case 'JobEvaTab':
                    this.$nextTick(()=> {
                        this.$refs.rate[0].getRate();
                    })
                    break;
                case 'JobOfferPriceTab':
                    this.$nextTick(()=> {
                        this.$refs.JobOfferPriceRef[0].getJobOfferList(this.jobData);
                    })
                    break;
                // default:
                //     break;
            }
        },
        // 点击添加备注
        addRemarkFun(){
            this.$refs.jobLog.addRemarkFun()
        },
        // 获取工单日志
        getJobLogList(){
            console.log("getJobLogList");
            this.$refs.jobLog.getRemarkList()
        },
        jobRequireConfirm(isSender){
            // console.log("isSender:"+isSender);
            // console.log("his.jobData.JobBaseInfo:"+JSON.stringify(this.jobData.JobBaseInfo));
            // console.log("his.jobDetailInfo:"+JSON.stringify(this.jobData.JobDetailInfo));
          
             this.$refs.jobRequireConfirm.openDia(this.jobData.JobBaseInfo,this.jobData.JobDetailInfo,isSender);
        },
        //回调
         getJobOfferPrice(){
            console.log('b2bJobInfo页面，加载工单报价');
            this.$nextTick(()=> {
                console.log("JobOfferPriceRef:"+ this.$refs.JobOfferPriceRef)
                if(this.$refs.JobOfferPriceRef)  {
                  this.$refs.JobOfferPriceRef[0].getJobOfferList(this.jobData);
                }
          }) 
}
    },
    beforeRouteLeave(to, from, next){
        if(to.name != 'b2bJobInfo') {
            this.$refs.stateBox.clearCountdown()
        }
        next()
    }
   
};
</script>
<style lang="scss">
.section-box {
    .el-tabs--card>.el-tabs__header .el-tabs__item {
        min-width: 110px;
        text-align: center;
    }
   
}
</style>